export default __webpack_public_path__ + "static/media/deauville19.b53d212d.jpg";